module.exports = __webpack_public_path__ + "ptc_momoro_W2.28fa3d29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_W2.jpg
// module id = na/r
// module chunks = 0